export default __webpack_public_path__ + "static/media/Gloves of the Ravenflight.8d9ed85b.jpg";